import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CheckBox from '../../CheckBox/index';

import sortCaret from '../../../assets/images/sort-caret.svg';
import './TableHeader.scss';

class TableHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      /** This is only used if props.hasMultiSelect is true */
      checkboxChecked: this.props.multiSelectEnabled || false,
    };

    this.toggleMultiSelect = this.toggleMultiSelect.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.multiSelectEnabled != prevProps.multiSelectEnabled) {
      this.setState({ checkboxChecked: this.props.multiSelectEnabled });
    }
  }

  toggleMultiSelect() {
    if (this.props.handleMultiSelect) {
      this.props.handleMultiSelect(!this.state.checkboxChecked, this.props.item);
    }
    this.setState({ checkboxChecked: !this.state.checkboxChecked });
  }

  createHeaderCell(type, headerName, first, index) {
    const { sortedType, reportType, sortDisabled } = this.props;
    let typeClass = type ? (reportType + '-' + type + ' ') : ' ';
    let divider = first ? '' : <div className='divider' />;
    if (sortedType == type) {
      return this.createSelectedHeaderCell(type, headerName, divider, index);
    }

    if ((reportType == 'reference-documents' && type == 'tasks')
      || (reportType == 'activity-log' && type == 'description')
      || (reportType == 'users' && (type == 'email' || type == 'phone' || type == 'markets' || type == 'options'))) {
      return (
        <div key={index} className={'header-cell ' + typeClass}>
          <div className="divider" />
          {this.createHeaderText(headerName)}
        </div>
      );
    }

    if ((reportType == 'project' && type == 'id') || reportType == 'inventory') {
      return (
        <div key={index} className={'header-cell ' + typeClass}>
          {this.createHeaderText(headerName)}
        </div>
      );
    }

    return (
      <div key={index} className={'header-cell ' + typeClass + (!sortDisabled ? 'sortable' : '')}>
        {divider}
        {this.createHeaderText(headerName)}
        {this.props.handleSort ?
          <div className='caret-container'>
            <img className='caret rotate' src={sortCaret} alt='' onClick={() => this.props.handleSort(type, 'up')} />
            <img className='caret' src={sortCaret} alt='' onClick={() => this.props.handleSort(type, 'down')} />
          </div> :
          null}
      </div>
    );
  }

  createSelectedHeaderCell(type, headerName, divider, index) {
    const { sortedType, sortDirectionClass, reportType, sortDisabled } = this.props;

    let typeClass = type ? (reportType + '-' + type + ' ') : ' ';

    return (
      <div key={index} className={'header-cell ' + typeClass + (!sortDisabled ? 'sortable' : '')}>
        {divider}
        {this.createHeaderText(headerName)}
        {this.props.handleSort ?
          <div className={`caret-container ${sortDirectionClass}`}>
            <img className='caret rotate selected' src={sortCaret} alt='' onClick={() => this.props.handleSort(sortedType, sortDirectionClass == 'down' ? 'down' : 'up')} />
            <img className='caret' src={sortCaret} alt='' onClick={() => this.props.handleSort(sortedType, sortDirectionClass == 'down' ? 'up' : 'down')} />
          </div>
          : null
        }
      </div>
    );
  }

  createHeaderText(headerName) {
   
    return (
      <div className='header-cell-text'>
        { headerName }
      </div>
    );
  }

  handleHeaderCell() {
    const { caretTypes } = this.props;

    return caretTypes.map((typeObj, index) => {
      const { type, headerName, first } = typeObj;
      return this.createHeaderCell(type, headerName, first, index);
    });
  }

  render() {
    const { accent, hasMultiSelect, hasMultiSelectFirst } = this.props;

    return (
      <div className={'table-header' + (hasMultiSelectFirst ? ' table-header--with-checkbox-first' : '') + (hasMultiSelect ? ' table-header--with-checkbox' : '')}  style={{ backgroundColor: accent || '#CD043A' }} >
        {
          hasMultiSelectFirst &&
            <CheckBox toggleCheckBox={this.toggleMultiSelect} checked={this.state.checkboxChecked}/>
        }
        <div className='table-header__cells' style={{ backgroundColor: accent || '#CD043A' }}>
          { this.handleHeaderCell() }
        </div>
        {
          hasMultiSelect &&
          <div className='table-header__select-area'>
            <CheckBox toggleCheckBox={this.toggleMultiSelect} checked={this.state.checkboxChecked}/>
            <span onClick={this.toggleMultiSelect}>SELECT ALL</span>
          </div>
        }
      </div>
    );
  }

}

export default TableHeader;

TableHeader.propTypes = {
  sortDirectionClass: PropTypes.string,
  accent: PropTypes.string,
  sortedType: PropTypes.string,
  handleSort: PropTypes.func,
  sortDisabled: PropTypes.bool,
  caretTypes: PropTypes.array.isRequired,
  reportType: PropTypes.string.isRequired,
  /** 
   * if enabled, there will be a multi-select checkbox which selects all rows
   * Currently, the parent component is responsible for facilitating the selection of the rows
   * TODO: combine rows and header to abstract this
   */
  hasMultiSelect: PropTypes.bool,
  /** multiSelect callback */
  handleMultiSelect: PropTypes.func,
  multiSelectEnabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Table/TableHeader/index.js